
import ResourceItem from './resourceItem.vue';
import ConfirmBtn from '@/components/ConfirmBtn/index.vue';
import * as api from '@/config/api';

export default {
  components: {
    ResourceItem: ResourceItem,
    ConfirmBtn: ConfirmBtn
  },
  props: {
    canSelect: Boolean,
    selectConfig: {
      type: Object,
      default: function _default() {
        return {
          type: 'checkbox',
          defaultList: [], // 默认选中值
          handleChange: function handleChange() {}
        };
      }
    },
    item: Object,
    handleUpdate: Function,
    handleDelete: Function
  },
  computed: {
    isCheckbox: function isCheckbox() {
      if (this.selectConfig.type) {
        return this.selectConfig.type === 'checkbox';
      }
      // 兼容旧调用，没有type的场景
      return true;
    },
    isRadio: function isRadio() {
      return this.selectConfig.type === 'radio';
    },
    downloadUrl: function downloadUrl() {
      return api.resStoreDownloadUrl;
    }
  },
  methods: {
    isDisabled: function isDisabled(id) {
      return (this.selectConfig.defaultList || []).indexOf(Number(id)) !== -1;
    },
    isChecked: function isChecked(id) {
      return (this.selectConfig.defaultList || []).indexOf(Number(id)) !== -1;
    }
  }
};